// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"804":"4b10f5fb","863":"9957ff95"}[chunkId] + ".chunk.js";
};